import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { TabsPage } from "./tabs.page";
import { GnxGuard } from "../../../services/guards/gnx-token.guard";
import { ValidateInfoExtraRegisterGuard } from "src/app/services/guards/validate-info-extra-register.guard";

const routes: Routes = [
  {
    path: "app",
    component: TabsPage,
    children: [
      {
        path: "home",
        loadChildren: () =>
          import("../home/home.module").then((m) => m.HomePageModule),
          canActivate: [GnxGuard,ValidateInfoExtraRegisterGuard],
      },
      {
        path: "content",
        loadChildren: () =>
          import("../content/content.module").then((m) => m.ContentPageModule),
          canActivate: [GnxGuard],
      },
      {
        path: "kpi",
        loadChildren: () =>
          import("../kpi/kpi.module").then((m) => m.KpiPageModule),
          canActivate: [GnxGuard],
      },
      {
        path: "orders",
        loadChildren: () =>
          import("../orders/orders.module").then((m) => m.OrdersPageModule),
          canActivate: [GnxGuard],
      },
      {
        path: "orders-detail",
        loadChildren: () =>
          import("../order-detail/order-detail.module").then(
            (m) => m.OrderDetailPageModule
          ),
          canActivate: [GnxGuard],
      },
      {
        path: "history",
        loadChildren: () =>
          import("../history-points/history-points.module").then(
            (m) => m.HistoryPointsPageModule
          ),
          canActivate: [GnxGuard],
      },
      {
        path: "orders-success",
        loadChildren: () =>
          import("../orders-success/orders-success.module").then(
            (m) => m.OrdersSuccessPageModule
          ),
          canActivate: [GnxGuard],
      },
      {
        path: "catalogue",
        loadChildren: () =>
          import("../catalogue/catalogue.module").then(
            (m) => m.CataloguePageModule
          ),
          canActivate: [GnxGuard],
      },
      {
        path: "catalogue/:id",
        loadChildren: () =>
          import("../catalogue-detail/catalogue-detail.module").then(
            (m) => m.CatalogueDetailPageModule
          ),
        canActivate: [GnxGuard]
      },
      {
        path: "nequi",
        loadChildren: () =>
          import("../nequi/nequi.module").then(
            (m) => m.NequiPageModule
          ),
          canActivate: [GnxGuard],
      },
      {
        path: "profile",
        loadChildren: () =>
          import("../profile/profile.module").then((m) => m.ProfilePageModule),
          canActivate: [GnxGuard],
      },
      {
        path: "map",
        loadChildren: () =>
          import("../map/map.module").then((m) => m.MapPageModule),
          canActivate: [GnxGuard],
      },

      {
        path: "terms-and-conditions",
        loadChildren: () =>
          import("../page-terms-conditions/page-terms-conditions.module").then(
            (m) => m.PageTermsConditionsPageModule
          ),
          canActivate: [GnxGuard],
      },
      {
        path: "privacy-policies",
        loadChildren: () =>
          import("../privacy-policies/privacy-policies.module").then(
            (m) => m.PrivacyPoliciesPageModule
          ),
          canActivate: [GnxGuard],
      },
      // {
      //   path: "social",
      //   loadChildren: () =>
      //     import("../social/social.module").then((m) => m.SocialPageModule),
      //     canActivate: [GnxGuard],
      // },
      {
        path: "social-user-profile/:path/:id",
        loadChildren: () =>
          import(
            "../social-user-profile/social-user-profile.module"
          ).then((m) => m.SocialUserProfilePageModule),
        canActivate: [GnxGuard],
      },
      {
        path: "social-notifications/:path",
          loadChildren: () =>
            import(
              "../social-notifications/social-notifications.module"
            ).then((m) => m.SocialNotificationsPageModule),
        canActivate: [GnxGuard]
      },
      {
        path: "social-post-by-hashtag",
          loadChildren: () =>
            import(
              "../social-post-by-hashtag/social-post-by-hashtag.module"
            ).then((m) => m.SocialPostByHashtagPageModule),
        canActivate: [GnxGuard]
      },
      {
        path: "challenges",
        loadChildren: () =>
          import("../challenges/challenges.module").then((m) => m.ChallengesPageModule),
          canActivate: [GnxGuard],
      },
      {
        path: "challenges/detail/:type/:id",
        loadChildren: () =>
          import("../challenges-detail/challenges-detail.module").then(
            (m) => m.ChallengesDetailPageModule
          ),
          canActivate: [GnxGuard],
      },
      {
        path: "challenges/form/:type/:id",
        loadChildren: () =>
          import("../challenges-form/challenges-form.module").then(
            (m) => m.ChallengesFormPageModule
          ),
          canActivate: [GnxGuard],
      },
      {
        path: 'invoices',
        loadChildren: () => import('../invoices/invoices.module').then( m => m.InvoicesPageModule)
      },
      {
        path: 'invoice/detail/:id',
        loadChildren: () => import('../invoice-detail/invoice-detail.module').then( m => m.InvoiceDetailPageModule)
      },
      {
        path: 'invoice/form',
        loadChildren: () => import('../invoice-form/invoice-form.module').then( m => m.InvoiceFormPageModule)
      },
      {
        path: 'invoice/request-received/:id',
         loadChildren: () => import('../invoices/received-request/received-request.module').then(m => m.ReceivedRequestPageModule)
      },
      {
        path: "exhibitions",
        loadChildren: () =>
          import("../exhibitions/exhibitions.module").then((m) => m.ExhibitionsPageModule),
          canActivate: [GnxGuard],
      },
      {
        path: "exhibitions/form",
        loadChildren: () =>
          import("../exhibition-form/exhibition-form.module").then((m) => m.ExhibitionFormPageModule),
          canActivate: [GnxGuard],
      },
      {
        path: "exhibitions/detail/:id",
        loadChildren: () =>
          import("../exhibition-detail/exhibition-detail.module").then((m) => m.ExhibitionDetailPageModule),
          canActivate: [GnxGuard],
      },
      {
        path: "exhibition-success",
        loadChildren: () =>
          import("../exhibition-success/exhibition-success.module").then((m) => m.ExhibitionSuccessPageModule),
          canActivate: [GnxGuard],
      },
      {
        path: "change-password",
        loadChildren: () =>
          import("../change-password/change-password.module").then(
            (m) => m.ChangePasswordPageModule
          ),
          canActivate: [GnxGuard],
      },
      {
        path: "change-phone",
        loadChildren: () =>
          import("../change-phone/change-phone.module").then(
            (m) => m.ChangePhonePageModule
          ),
          canActivate: [GnxGuard],
      },
      {
        path: "change-email",
        loadChildren: () =>
          import("../../public/change-email/change-email.module").then(
            (m) => m.ChangeEmailPageModule
          ),
          canActivate: [GnxGuard],
      },
      {
        path: "",
        redirectTo: "/app/home",
        pathMatch: "full",
      },
      {
        path: "content",
        loadChildren: () =>
          import("../content/content.module").then((m) => m.ContentPageModule),
          canActivate: [GnxGuard],
        //canActivate: [AngularFireAuthGuard],
        //data: { authGuardPipe: redirectUnauthorized },
      },
      {
        path: "content/:type/:id",
        loadChildren: () =>
          import("../content-detail/content-detail.module").then(
            (m) => m.ContentDetailPageModule
          ),
          canActivate: [GnxGuard],
        //canActivate: [AngularFireAuthGuard],
        //data: { authGuardPipe: redirectUnauthorized },
      },
      {
        path: 'game',
        loadChildren: () => import('../gamification-tab-status/gamification-tab-status.module').then(
            m => m.GamificationTabStatusPageModule),
            canActivate: [GnxGuard],
      },
      {
        path: 'status',
        loadChildren: () => import('../gamification-tab-status/gamification-tab-status.module').then(
            m => m.GamificationTabStatusPageModule),
            canActivate: [GnxGuard],
      },
      {
        path: 'geochallenges',
        loadChildren: () =>
        import('../geochallenges-tabs/geochallenges-tabs.module').then(
          m => m.GeochallengesTabsPageModule),
          canActivate: [GnxGuard],
      },
      {
        path: 'geochallenges/form/:type/:id',
        loadChildren: () =>
        import('../geochallenges-form/geochallenges-form.module').then(
          m => m.GeochallengesFormPageModule),
          canActivate: [GnxGuard],
      },
      {
        path: 'geochallenges/detail/:type/:id',
        loadChildren: () =>
        import('../geochallenges-detail/geochallenges-detail.module').then(
          m => m.GeochallengesDetailPageModule),
          canActivate: [GnxGuard],
      },
      {
        path: 'total-pass',
        loadChildren: () => import('../total-pass/total-pass.module').then( m => m.TotalPassPageModule),
        canActivate: [GnxGuard],
      },
      {
        path: 'delete-account-term',
        loadChildren: () => import('../delete-account/delete-account-term/delete-account-term.module').then( m => m.DeleteAccountTermPageModule)
      },
      {
        path: 'delete-account-confirmation',
        loadChildren: () => import('../delete-account/delete-account-confirmation/delete-account-confirmation.module').then( m => m.DeleteAccountConfirmationPageModule)
      },
      {
        path: 'recognitions-form',
        loadChildren: () => import('../recognitions-form/recognitions-form.module').then( m => m.RecognitionsFormPageModule)
      },
      {
        path: 'recognitions',
        loadChildren: () => import('../recognitions/recognitions.module').then( m => m.RecognitionsPageModule)
      },
      {
        path: 'recognitions-success',
        loadChildren: () => import('../recognitions-success/recognitions-success.module').then( m => m.RecognitionsSuccessPageModule)
      },
      {
        path: 'shopping-cart',
        loadChildren: () => import('../shopping-cart/shopping-cart.module').then( m => m.ShoppingCartPageModule)
      },
      {
        path: 'confirm-checkout',
        loadChildren: () => import('../confirm-checkout/confirm-checkout.module').then( m => m.ConfirmCheckoutPageModule)
      },
      {
        path: 'checkout',
        loadChildren: () => import('../checkout/checkout.module').then( m => m.CheckoutPageModule)
      },
      {
        path: 'payment-services',
        loadChildren: () => import('../payment-services/payment-services.module').then(m => m.PaymentServicesPageModule)
      },
      {
        path: 'payment-services/requestReceived/:id/:status',
        loadChildren: () => import('../payment-services/request-received/request-received.module').then(m => m.RequestReceivedPageModule)
      },
      {
        path: 'pay-services-automatic',
        loadChildren: () => import('../pay-public-services-automatic/pay-public-services-automatic.module').then( m => m.PayPublicServicesAutomaticPageModule)
      },
      {
        path: 'payment-terminal',
        loadChildren: () => import('../payment-terminal/payment-terminal.module').then(m => m.PaymentTerminalPageModule)
      },
      {
        path: 'payment-terminal-key',
        loadChildren: () => import('../payment-terminal-key/payment-terminal-key.module').then(m => m.PaymentTerminalKeyPageModule)
      },
      {
        path: 'app-key-termminal-success',
        loadChildren: () => import('../key-termminal-success/key-termminal-success.module').then(m => m.KeyTermminalSuccessPageModule)
      },
      {
        path: 'brands',
        loadChildren: () => import('../brands/brands-routing.module').then(m => m.BrandsPageRoutingModule)
      },
      {
        path: 'brands/:id',
        loadChildren: () => import('../brands/brands-routing.module').then(m => m.BrandsPageRoutingModule)
      }

    ],
  },
  {
    path: "",
    redirectTo: "/app/home",
    pathMatch: "full",
    canActivate: [GnxGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TabsPageRoutingModule {}
